const phoneToE164 = (phone: string): string => {
  if (!phone) {
    return phone;
  }

  // Remove todos os caracteres não numéricos
  const phoneDigits = phone.replace(/\D/g, "");

  // Remove código do país se já estiver presente
  let cleanDigits = phoneDigits;
  if (phoneDigits.startsWith("55") && phoneDigits.length >= 12) {
    cleanDigits = phoneDigits.slice(2);
  }

  // Verifica se tem pelo menos 10 dígitos (formato brasileiro)
  if (cleanDigits.length < 10) {
    throw new Error("Telefone deve ter pelo menos 10 dígitos");
  }

  // Verifica se tem no máximo 11 dígitos
  if (cleanDigits.length > 11) {
    throw new Error("Telefone deve ter no máximo 11 dígitos");
  }

  // Se tem 11 dígitos, verifica se começa com 9 (celular)
  if (cleanDigits.length === 11 && cleanDigits[2] !== "9") {
    throw new Error("Celular deve começar com 9");
  }

  // Se tem 10 dígitos, verifica se é telefone fixo válido
  if (cleanDigits.length === 10) {
    // Telefone fixo deve começar com 2, 3, 4 ou 5
    if (!["2", "3", "4", "5"].includes(cleanDigits[2])) {
      throw new Error("Telefone fixo deve ter DDD válido");
    }
  }

  // Adiciona código do país Brasil (55) e formata como E.164
  return `+55${cleanDigits}`;
};

export default phoneToE164;
